import "./sidebar.css"
import {List, ListItem, ListItemButton, ListItemIcon, ListItemText} from "@mui/material";

import {FilterAltOffOutlined, PsychologyAltOutlined} from "@mui/icons-material";
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import React, {useState, useEffect} from "react";
import SchoolIcon from "@mui/icons-material/School";
import GroupsIcon from "@mui/icons-material/Groups";
import getStoredValue from "../../services/UseLocalStorage";
import {NAME_HEADER_AUTH} from "../../utils/Constants";
import BoltIcon from "@mui/icons-material/Bolt";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { Collapse } from "@mui/material";
import PaidIcon from "@mui/icons-material/Paid";
import FileCopyIcon from '@mui/icons-material/FileCopy';


export default function SidebarComponent({
    isSidebarOpen,
    setSidebarOpen,
    showVaultGrid,
    setShowVaultGrid,
    selectedOfferSubitem,
    setSelectedOfferSubitem,
    onFirstNavigation,
    setShowIASearch,
    setShowClonePages
}) {

    /**
     * Nombre actual de la clase que usa el sidebar.
     * @type {string}
     */
        // isSidebarOpen = true
    let classNameSideBar = isSidebarOpen ? "sidebar-component open" : "sidebar-component"
    // On first render, no selected item (OfferView is shown in App)
    const [listItemSelected, setListItemSelected] = useState(null)

    const [openNichos, setOpenNichos] = useState(false);
    
    // Collapse nichos when sidebar closes
    useEffect(() => {
        if (!isSidebarOpen && openNichos) {
            setOpenNichos(false);
        }
    }, [isSidebarOpen, openNichos]);    
    
    const handleNichosClick = () => {
        // Asegura que el sidebar se abra completamente al hacer clic en "Ofertas"
        if (!isSidebarOpen) {
            setSidebarOpen(true);
        }
        // Si el sidebar ya está abierto, simplemente alterna el colapso
        setOpenNichos(prev => !prev || !isSidebarOpen); // garantiza que se abra la sección al abrir sidebar
    };

    const handleOfferSubitemClick = (subitemName) => {
        setShowVaultGrid(false); // Ensure Biblioteca grid is hidden
    if (typeof setShowIASearch === 'function') setShowIASearch(false);
    if (typeof setShowClonePages === 'function') setShowClonePages(false);
        setSelectedOfferSubitem(subitemName);
        setListItemSelected(subitemName); // Optional: highlight selected subitem
    if (typeof onFirstNavigation === 'function') onFirstNavigation();
    };
        

    const handleNavigation = (uri) => {
        const auth = getStoredValue(NAME_HEADER_AUTH);
        switch (uri) {
            case 'dashboard':
                setShowVaultGrid(true);
                if (typeof setShowIASearch === 'function') setShowIASearch(false);
                if (typeof setShowClonePages === 'function') setShowClonePages(false);
                setSelectedOfferSubitem(null);
                break;
            case 'fast genius':
                setShowVaultGrid(false);
                if (typeof setShowIASearch === 'function') setShowIASearch(false);
                if (typeof setShowClonePages === 'function') setShowClonePages(false);
                setSelectedOfferSubitem(null);
                break;
            case 'iasearch':
                setShowVaultGrid(false);
                if (typeof setShowIASearch === 'function') setShowIASearch(true);
                if (typeof setShowClonePages === 'function') setShowClonePages(false);
                setSelectedOfferSubitem(null);
                break;
            case 'clone_pages':
                setShowVaultGrid(false);
                if (typeof setShowIASearch === 'function') setShowIASearch(false);
                if (typeof setShowClonePages === 'function') setShowClonePages(true);
                setSelectedOfferSubitem(null);
                break;
            default:
                window.location.href = `https://app.pulpoia.com/${uri}?token=${auth}`;
        }
        // Highlight the clicked option from now on
        setListItemSelected(uri);
    if (typeof onFirstNavigation === 'function') onFirstNavigation();
    }

    return (
        <div className={classNameSideBar}>
            <List>
                <ListItem
                    className={listItemSelected === 'fast genius' ? "listItem-selected" : "listItem-normal"}
                    disablePadding
                    onClick={() => handleNavigation('fast genius')}
                    sx={{
                        mt: 1
                    }}>
                    <ListItemButton>
                        <ListItemIcon>
                            <BoltIcon/>
                        </ListItemIcon>
                        {isSidebarOpen && (<ListItemText primary="Cazar Presas"/>)}
                    </ListItemButton>
                </ListItem>
                <ListItem
                    className={listItemSelected === 'dashboard' ? "listItem-selected" : "listItem-normal"}
                    disablePadding
                    onClick={() => handleNavigation('dashboard')}>
                    <ListItemButton>
                        <ListItemIcon>
                            <PsychologyAltOutlined />
                        </ListItemIcon>
                        {isSidebarOpen && (<ListItemText primary="Baúl"/>)}
                    </ListItemButton>
                </ListItem>

                {/* Pulpo IA */}
                <ListItem
                    className={listItemSelected === 'iasearch' ? "listItem-selected" : "listItem-normal"}
                    disablePadding
                    onClick={() => handleNavigation('iasearch')}>
                    <ListItemButton>
                        <ListItemIcon>
                            <AutoAwesomeIcon/>
                        </ListItemIcon>
                        {isSidebarOpen && (<ListItemText primary="Pulpo IA"/>)}
                    </ListItemButton>
                </ListItem>
                {/* <ListItem disablePadding
                          onClick={() => handleNavigation('funnels')}
                          sx={{width: '100%'}}>
                    <ListItemButton>
                        <ListItemIcon>
                            <FilterAltOffOutlined/>
                        </ListItemIcon>
                        {isSidebarOpen && (<ListItemText primary="Embudos"/>)}
                    </ListItemButton>
                </ListItem> */}
         
                {/* <ListItem disablePadding
                          onClick={() => window.location.href = 'https://whatsapp.com/'}
                          sx={{width: '100%'}}>
                    <ListItemButton>
                        <ListItemIcon>
                            <GroupsIcon/>
                        </ListItemIcon>
                        {isSidebarOpen && (<ListItemText primary="Comunidad"/>)}
                    </ListItemButton>
                </ListItem> */}
                <ListItem disablePadding sx={{width: '100%'}} onClick={handleNichosClick}>
                    <ListItemButton>
                        <ListItemIcon>
                            <PaidIcon/>
                        </ListItemIcon>
                        {isSidebarOpen && (
                            <>
                                <ListItemText primary="Ofertas" />
                                {openNichos ? <ExpandLess /> : <ExpandMore />}
                            </>
                        )}
                    </ListItemButton>
                </ListItem>
                <Collapse in={openNichos} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding sx={{pl: isSidebarOpen ? 4 : 2}}>
                        <ListItemButton sx={{pl: 2}} onClick={() => handleOfferSubitemClick("Dinero")}>
                            <ListItemText primary="Dinero" />
                        </ListItemButton>
                        <ListItemButton sx={{pl: 2}} onClick={() => handleOfferSubitemClick("Relaciones")}>
                            <ListItemText primary="Relaciones" />
                        </ListItemButton>
                        <ListItemButton sx={{pl: 2}} onClick={() => handleOfferSubitemClick("Salud")}>
                            <ListItemText primary="Salud" />
                        </ListItemButton>
                        <ListItemButton sx={{pl: 2}} onClick={() => handleOfferSubitemClick("Gastronomía")}>
                            <ListItemText primary="Gastronomía" />
                        </ListItemButton>

                        <ListItemButton sx={{pl: 2}} onClick={() => handleOfferSubitemClick("Manualidades")}>
                            <ListItemText primary="Manualidades" />
                        </ListItemButton>
                        <ListItemButton sx={{pl: 2}} onClick={() => handleOfferSubitemClick("Belleza")}>
                            <ListItemText primary="Belleza" />
                        </ListItemButton>
                        <ListItemButton sx={{pl: 2}} onClick={() => handleOfferSubitemClick("Finanzas")}>
                            <ListItemText primary="Finanzas" />
                        </ListItemButton>
                        <ListItemButton sx={{pl: 2}} onClick={() => handleOfferSubitemClick("Emprendimiento")}>
                            <ListItemText primary="Emprendimiento" />
                        </ListItemButton>


                        <ListItemButton sx={{pl: 2}} onClick={() => handleOfferSubitemClick("Físicos")}>
                            <ListItemText primary="Físicos" />
                        </ListItemButton>
                        <ListItemButton sx={{pl: 2}} onClick={() => handleOfferSubitemClick("Otros")}>
                            <ListItemText primary="Otros" />
                        </ListItemButton>
                    </List>
                </Collapse>             
                <ListItem
                    className={listItemSelected === 'clone_pages' ? "listItem-selected" : "listItem-normal"}
                    disablePadding
                    onClick={() => handleNavigation('clone_pages')}>
                    <ListItemButton>
                        <ListItemIcon>
                            <FileCopyIcon/>
                        </ListItemIcon>
                        {isSidebarOpen && (<ListItemText primary="Clonar páginas"/>)}
                    </ListItemButton>
                </ListItem>
            </List>
        </div>
    );
}